'use client'

import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { Button } from 'antd'
import { useTranslation } from '@/i18n/client'
import { usePathname } from 'next/navigation'
import Png404 from '@/public/404.png'

export function NotFound() {
  const router = useRouter()
  const pathname = usePathname()
  const { t } = useTranslation(pathname.split('/')[1])

  return (
    <div className="container mb-[.25rem] py-12 md:py-18">
      <Image className="m-auto block w-full max-w-[350px]" src={Png404} width={350} height={350} priority alt="404" />
      <div className="mt-[.5rem] pt-8 text-center md:pt-12">
        <h6 className="mb-[.5rem] text-[1rem] leading-[1.2] text-[#6c757d]">{t('notFound.title')}</h6>
      </div>
      <div className="text-center">
        <div className="flex flex-col items-center sm:block sm:flex-row ">
          <Button type="primary" shape="round" className="mr-1.25 mt-2 h-[44px] w-auto px-[31px] py-3 uppercase leading-[10px]" onClick={() => router.push('/')}>
            {t('notFound.backHome')}
          </Button>
          <Button type="primary" shape="round" className="mt-3.75 sm:mt-2 ml-0 sm:ml-2.5 h-[44px] w-auto px-[31px] py-3 uppercase leading-[10px]" onClick={() => router.back()}>
            {t('notFound.backPrev')}
          </Button>
        </div>
      </div>
    </div>
  )
}
